export const FETCH_LIST = 'STORIES/FETCH_LIST'
export const SEND_EVENT = 'STORIES/SEND_EVENT'
export const RESET_DATA = 'STORIES/RESET_DATA'
export const SET_DATA = 'STORIES/SET_DATA'
